import { faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {

    const items = [

        {
            title: 'Careers',
            url: '/career',
            icon: faArrowAltCircleRight
        },
        {
            title: 'About Banco Connect',
            url: '/aboutUs',
            icon: faArrowAltCircleRight
        }
    ];

    const showLinks = () => (
        items.map((item, i) => (

                <Link className='btn-link' to={item.url} key={i}>
                    {item.title}
                    <FontAwesomeIcon icon={item.icon} />
                </Link>
        ))
    )

    return (
        <div className='about-us-container'>

            <div className='about-us-picture' style={{
                background: `url(/images/about-us.png)`
            }}>

            </div>


            <div className='about-us-links'>
                {showLinks()}
            </div>

        </div>
    );
};

export default AboutUs;
